
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","id":"ico-freigabe","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"id":"bg","d":"M0 0h24v24H0z","fill":"none"}}),_c('g',{attrs:{"id":"ico","transform":"translate(-458.005 -375.365)"}},[_c('g',{attrs:{"id":"Gruppe_27712","data-name":"Gruppe 27712","transform":"translate(462.005 379.365)"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Pfad_14185","d":"M471.912 390.643a6.433 6.433 0 00-9.912 5.415.586.586 0 00.587.587h7.022a.587.587 0 100-1.173h-6.4a5.259 5.259 0 018.064-3.841.586.586 0 00.634-.986z","data-name":"Pfad 14185","transform":"translate(-462.005 -381.6)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Pfad_14186","d":"M469.187 386.851a3.743 3.743 0 10-3.743-3.743 3.748 3.748 0 003.743 3.743zm0-6.313a2.57 2.57 0 11-2.57 2.569 2.573 2.573 0 012.57-2.569z","data-name":"Pfad 14186","transform":"translate(-462.754 -379.365)"}})]),_c('g',{attrs:{"id":"Gruppe_27713","data-name":"Gruppe 27713","transform":"translate(470.727 388.646)"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Pfad_14187","d":"M476.8 398.51a.581.581 0 01-.58-.581v-2.479h-2.479a.58.58 0 010-1.161h2.479v-2.478a.58.58 0 011.161 0v2.478h2.479a.58.58 0 010 1.161h-2.479v2.479a.581.581 0 01-.581.581z","data-name":"Pfad 14187","transform":"translate(-473.156 -391.231)"}})])])])
          )
        }
      }
    